import { Button, ButtonProps, ButtonStylesNames, ButtonStylesParams, Styles, Text, useMantineTheme } from "@mantine/core";
import { IconName } from "../Icons/Icons/iconRegistry";
import Icon from "../Icons/Icons/Icon";
import { COLORS, FONT_SIZES } from "src/utils/styles";
import { useColorScheme } from "@mantine/hooks";
import { colors } from "@mui/material";

interface FocusButton {
  icon: IconName;
  text: string;
  iconSize?: string;
  w?: string;
  textSize?: number;
  loading?: boolean,
  onClick?: () => void,
  focused?: boolean
}

export const FocusButton = (props: FocusButton) => {
  const { text, icon, iconSize = "1rem", textSize = FONT_SIZES.text, onClick, focused, w } = props;
  const theme = useMantineTheme()

  return (
      <Button onClick={onClick} radius={10} styles={(theme) => ({
        root: {
            width: w || '100%',
            transition: 'transform 0.3s ease-in-out, background 0.3s ease-in-out', // Smooth transitions for transform and background changes
            ...(focused ? {
              transform: 'scale(1.1)', // Enlarge the button when focused
              background: COLORS.primary,
              '&:not([data-disabled])': theme.fn.hover({
                backgroundColor: COLORS.primary,
              }),
    
            } : {
              backgroundColor: theme.colorScheme === 'light' ? COLORS.lightButton : COLORS.darkButton,
              '&:not([data-disabled])': theme.fn.hover({
                backgroundColor: theme.fn[theme.colorScheme === 'light' ? 'darken' : 'lighten'](theme.colorScheme === 'light' ? COLORS.lightButton : COLORS.darkButton, 0.05),
              }),
            }),
          },
          inner: {
            justifyContent: 'flex-start',
          },
    }) } leftIcon={<Icon size={iconSize} color={focused ? "white" : theme.colorScheme == "dark" ? "white" : "black"} name={icon} />}>
        <Text style={{fontSize: textSize, color: focused ? "white" : theme.colorScheme == "dark" ? "white" : "black"}}>{text}</Text>
      </Button>
  );
};
